/**
 * Main component that represents the main layout of the application.
 * It renders the header, shop list, search bar, map, footer, and shop detail overlay.
 * Added documentation to test deployment.
 */

import React from 'react';
import { connect } from 'react-redux';
import Header from './Header';
import ShopList from '../containers/ShopListContainer';
import Search from '../components/Search';
import MapContainer from '../containers/MapContainer';
import Footer from '../components/Footer';
import ShopDetailOverlay from '../containers/ShopDetailOverlay';
import MobileControls from '../containers/MobileControls';
import Text from '../containers/Text';
import { getDict } from '../utilities/dict'

class Main extends React.Component {

  constructor(props) {
    console.log('App is initializing...');
    super(props);
  }

  render() {

    const { showHeader, currentTab, isFetching, showFooter, config } = this.props;

    const dict = getDict(config.language);

    return (
      <div className='main'>
        {showHeader ? <Header /> : null}

        <div className={`container-fluid main-content main-show-${currentTab}`}>
          <div className='row'>
            <div className='col-md-4 col-list p-0 content-wrapper'>
              <div className="shop-list__title py-xs px-md">
                <h1 className="t-h3-alt mb-0"><Text id='shop-list.title' /></h1>
                <div className="shop-list__title-icons text-end">
                  <span className={`spinner mr-md ${isFetching ? 'is-fetching' : ''}`}></span>
                  <button className="halflings halflings-print shop-list__print"
                    style={{height: '24px', width: '24px'}}
                    aria-label={dict('social-buttons.print')}
                    onClick={() => {
                      window.wts.push(['send', 'click', { linkId: 'Liste.Drucken' }]);
                      window.print();
                    }}>
                  </button>
                </div>
              </div>
              <Search />
              <MobileControls />
              <ShopList />
            </div>
            <div className='col-md-8 col-map p-0'>
              <MapContainer />
            </div>
          </div>
        </div>

        {showFooter ? <Footer /> : null}
        <ShopDetailOverlay />
      </div>
    );
  }
}

const mapStateToProps = ({ search, config, currentTab }) => ({
  isFetching: search.isFetching,
  currentTab,
  showHeader: !(config.noframe === true),
  showFooter: !(config.noframe === true),
  config
});

export default connect(mapStateToProps)(Main);

